import styled from "styled-components";
import { StyledBorrowingCalendarContent } from "./styles";
import clsx from "clsx";
import { useEffect, useRef} from "react";
import { format } from "date-fns";

interface IProps {
  data?: any;
  dateList?: any;
  holidays?: any;
}



export const BorrowingCalendarContent = (props: IProps) => {
  const { data, dateList, holidays } = props;
  const headerRef = useRef<HTMLTableRowElement>(null);
  const stickyHeaderContainerRef = useRef<HTMLDivElement>(null);
  const tableContainerRef = useRef<HTMLDivElement>(null);
  



  useEffect(() => {
    if (!dateList || dateList.length === 0 || !tableContainerRef.current) return;
    const today = format(new Date(), 'yyyy-MM-dd');

    const targetCell = tableContainerRef.current.querySelector(`thead th[data-date="${today}"]`) as HTMLElement;

    if (targetCell) {
      const container = tableContainerRef.current;
      const stickyCol1Width = (container.querySelector('.leftSticky:nth-child(1)') as HTMLElement)?.offsetWidth || 0;
      const stickyCol2Width = (container.querySelector('.leftSticky:nth-child(2)') as HTMLElement)?.offsetWidth || 0;
      const stickyOffset = stickyCol1Width + stickyCol2Width + 10;

      const scrollLeft = targetCell.offsetLeft - stickyOffset;

      container.scrollTo({
        left: scrollLeft > 0 ? scrollLeft : 0, // Ensure scrollLeft is not negative
        behavior: "auto", // Use 'auto' for immediate jump on load
      });
    }
  }, [dateList]);

  return (
    <StyledBorrowingCalendarContent ref={tableContainerRef}>
      <div className="calendar">
        <table className="table">
          <thead>
          
            <tr className="table__header" ref={headerRef}>
              <th className="leftSticky title"></th>
              <th className="leftSticky title"></th>
              {dateList?.map((day, index) => ( 
                <th
                  key={index}
                  data-date={day} 
                  className={clsx(holidays?.includes(day) ? "dayOff" : "day")} 
                >
             
                  {typeof day === 'string' ? day.slice(8, 10).replace(/^0+/, '') : ''}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data?.map((item: any) => (
              <tr key={item.id} className="">
                <td className="leftSticky">
                  {(item.delayBorrowings?.length > 0 || item.borrowings?.some(b => b.status === 'red')) &&
                    <div className="delay">遅延</div>
                  }
                </td>
                <td className="leftSticky">
                  {item?.name}
                </td>

                {dateList?.map((day, i) => { 

                  const borrowings = item.borrowings || [];

                  const isBlue = borrowings.some((b: any) => {
                    if (!b || b.status !== 'blue' || !b.from || !b.to) return false; 
                    try {
                        const from = new Date(b.from);
                        const to = new Date(b.to);
                        const current = new Date(day);
                        // Add validation for dates if necessary
                        if (isNaN(from.getTime()) || isNaN(to.getTime()) || isNaN(current.getTime())) return false;
                        return current >= from && current <= to;
                    } catch (e) {
                        console.error("Error parsing date:", b, day, e);
                        return false;
                    }
                  });

                  const isRed = borrowings.some((b: any) => {
                    if (!b || b.status !== 'red' || !b.from || !b.to) return false; 
                     try {
                        const current = new Date(day);
                        const from = new Date(b.from);
                        const to = new Date(b.to);
                        
                         if (isNaN(from.getTime()) || isNaN(to.getTime()) || isNaN(current.getTime())) return false;
                        return current >= from && current <= to;
                     } catch (e) {
                        console.error("Error parsing date:", b, day, e);
                        return false;
                    }
                  });

                  return (
                    <td key={i} className="table__event">
                      <div className="eventContainer">
                        {isBlue ? (
                          <div className="event">
                           
                          </div>
                        ) : isRed ? (
                          <div className="eventRed">
                         
                          </div>
                          ) : (
                            <div className="empty"></div>
                          )}
                      </div>
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </StyledBorrowingCalendarContent>
  );
};
